import { Model, Module, Action, store, ApiClient, Mutation } from './helpers'
import { TemplateLocationModel } from './interfaces'

export type TemplateLayoutType = 'fullsize'|'split'
export type TemplateWaitlistBasedOn = 'all'|'service_category'|'resources'|'service_staff_member'

export interface IPhotoData {
  attachment_file_name: string
  attachment_file_size: number
  attachment_updated_at: string
  arm: string
  large_arm: string
  id: number
  large_background: string
  logo: string
  logo_height: number
  logo_width: number
  medium: string
  mini: string
  original: string
  original_height: number
  original_width: number
  thumb: string
  created_at: string
  updated_at: string
  _destroy: true
}

export interface LogoData {
  photos: IPhotoData[]
}

export interface TemplateData {
  theme_color: string
  logo: LogoData
  waitlist_based_on: TemplateWaitlistBasedOn
  waitlist_item_ids?: number[]
}

export interface TemplateModel {
  id: number
  company_id?: number
  title: string
  data: TemplateData
  layout_type?: TemplateLayoutType
  location_ids?: number[]
  exclude_location_ids?: number[]
  template_locations: TemplateLocationModel[]
}

@Module
class TemplateModule extends Model<TemplateModel> {
  activeId: number = null
  entitiesByLocationId: { [key: string]: TemplateModel[] } = {}
  logoImageUrl: string = null
  themeColor: string = '#0D76BB'
  isLoading = false

  @Action async GET_TEMPLATES() {
    this.startLoading(true)
    const { data } = await ApiClient.get('/api/v1/digital_signage/templates.json?template_locations=true')
    this.STORE_ENTITIES(data.templates)
    this.INDEX_ENTITIES({ key: 'entitiesByLocationId', indexBy: this.indexTemplatesByLocationId })
    this.startLoading(false)
  }

  @Action SELECTED_TEMPLATE(template: TemplateModel) {
    this.SET_ACTIVE_TEMPLATE_ID(template.id)
    this.SET_LOGO_THUMBNAIL(template)
    this.SET_THEME_COLOR(template)
  }

  @Action RESET() {
    this.UNSET_ACTIVE_TEMPLATE_ID()
    this.UNSET_LOGO_THUMBNAIL()
  }

  @Mutation SET_ACTIVE_TEMPLATE_ID(id: number) {
    this.activeId = id
  }

  @Mutation SET_LOGO_THUMBNAIL(template: TemplateModel) {
    if (!template.data.logo || !template.data.logo.photos || !template.data.logo.photos.length) {
      return
    }
    const foundLogoImage = template.data.logo.photos.find((p) => !p._destroy)
    this.logoImageUrl = foundLogoImage && foundLogoImage.original || ''
  }

  @Mutation SET_THEME_COLOR(template: TemplateModel) {
    this.themeColor = template.data.theme_color || '#0D76BB'
  }

  @Mutation UNSET_ACTIVE_TEMPLATE_ID() {
    this.activeId = 0
  }
  @Mutation UNSET_LOGO_THUMBNAIL() {
    this.logoImageUrl = null
  }

  @Mutation startLoading(isLoading: boolean = true) {
    this.isLoading = isLoading
  }

  private indexTemplatesByLocationId(template: TemplateModel): string[] {
    return template.template_locations.map((templateLocation) => {
      return `${templateLocation.location_id}`
    })
  }
}

export const Templates = new TemplateModule({ store, name: 'Templates' })
